import { FormEventHandler, MutableRefObject } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Company, PrivilegesItem, UserSearchConditions } from '../../../api/model';
import MultiSelect from '../../atoms/MultiSelect';
import SlideToggle from '../../modules/SlideToggle';

interface Props {
  openSearchConditions: boolean;
  license: string;
  defaultConditions: UserSearchConditions;
  companies: Company[];
  privileges: PrivilegesItem[];
  conditionsRef: MutableRefObject<UserSearchConditions>;
  setConditionsAndSearch: (value: UserSearchConditions) => void;
}

// Companies
function UserSearch({
  openSearchConditions,
  license,
  defaultConditions,
  companies,
  privileges,
  conditionsRef,
  setConditionsAndSearch,
}: Props) {
  const { t } = useTranslation();

  // フォーム情報
  const { control, register, handleSubmit } = useForm<UserSearchConditions>({
    defaultValues: { ...defaultConditions },
  });

  // フォーム送信
  const onSubmit: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    void handleSubmit((data) => {
      const next: UserSearchConditions = {
        ...conditionsRef.current,
        user_id_text: data.user_id_text,
        user_name: data.user_name,
        company_ids: data.company_ids,
        privilege_ids: data.privilege_ids,
        deleted: data.deleted,
        displaygroup: false,
      };
      // 検索実行など
      setConditionsAndSearch(next);
    })();
  };

  return (
    <SlideToggle open={openSearchConditions}>
      <form id="production-search-conditions" onSubmit={onSubmit}>
        <div className="wfr scondition trigfr mb50 fropen">
          <div className="grid3 labip4">
            <div>
              <label htmlFor="user_id_text">{t('ユーザーID')}</label>
              <input type="text" id="user_id_text" {...register('user_id_text')} />
            </div>
            <div>
              <label htmlFor="user_name">{t('ユーザー名')}</label>
              <input type="text" id="user_name" {...register('user_name')} />
            </div>
            <div>
              <label htmlFor="company_ids">{t('会社名')}</label>
              <MultiSelect
                id="company_ids"
                name="company_ids"
                options={companies}
                control={control}
                isDisabled={false}
                getValue={(x) => x.company_id}
                getLabel={(x) => x.company_name}
              />
            </div>
          </div>
          <div className="grid3 labip4 mt10">
            <div>
              <label htmlFor="company_ids">{t('権限')}</label>
              <MultiSelect
                id="privilege_ids"
                name="privilege_ids"
                options={privileges}
                control={control}
                isDisabled={false}
                getValue={(x) => x.privilege_id}
                getLabel={(x) => x.privilege_name}
              />
            </div>
          </div>
          <div className="btnfr-all mb0 bfall1 conf-req-btn1fr">
            <div className="btnfr-left1">
              <p className="licensenum">
                <span>{t('有効なライセンス数 : ')}</span>
                {license}
              </p>
            </div>
            <div className="btnfr-right1">
              <div className="controlfr">
                <span className="ck">
                  <input id="deleted" type="checkbox" {...register('deleted')} />{' '}
                  <label htmlFor="deleted">{t('削除データ表示')}</label>
                </span>
                <span>
                  <input type="submit" value={t('検索').toString()} className="searchbtn" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </SlideToggle>
  );
}

export { UserSearch };
